// Normalises the attachment list of a process-request response.
//
// The API returns [{ url, name }] — url is the internal GUID storage path, name is the
// filename the user uploaded. Older API builds returned a bare list of paths under
// `attachmentUrls` instead. Accept both so the المرفقات section still renders when the
// frontend is newer than the deployed API (or vice-versa) rather than silently vanishing;
// on the old shape we fall back to the GUID filename, which is what those builds showed.
export function normalizeAttachments(data) {
    if (!data) {
        return []
    }
    if (Array.isArray(data.attachments) && data.attachments.length) {
        return data.attachments
    }
    return (data.attachmentUrls || []).map(url => ({
        url,
        name: String(url || '').split('/').pop()
    }))
}
